import { allPositions } from '../constants/postingData';

export const getUpdatedPostingData = (division, selectedPosition, gpa) => {
  const index = allPositions[division].findIndex(element => element.position === selectedPosition);
  const currentObject = allPositions[division][index];

  return {
    heightInInches: currentObject.inches,
    heightInFeet: currentObject.feet,
    height: `${currentObject.feet}'${currentObject.inches}`,
    t40: currentObject.t40,
    weight: currentObject.weight,
    description: currentObject.description,
    gpa,
  };
};

export const abc = () => {};




// WEBPACK FOOTER //
// ./src/common/utils/helpers.js